<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.firstName"
        :validator="vs.accountForm.firstName"
        :label="(isAdminLocalization ? adminText('adminAll.first_name_b6ea99', 'First Name') : $t('firstName', 'First Name'))"
        autofocus
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.lastName"
        :validator="vs.accountForm.lastName"
        :label="(isAdminLocalization ? adminText('adminAll.last_name_863cb3', 'Last Name') : $t('lastName', 'Last Name'))"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.email"
        :validator="vs.accountForm.email"
        :label="(isAdminLocalization ? adminText('adminAll.email_84add5', 'Email') : $t('email', 'Email'))"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field :admin-context="isAdminLocalization" v-model.trim="form.Address" :label="(isAdminLocalization ? adminText('adminAll.address_d70f93', 'Address') : $t('address', 'Address'))" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field :admin-context="isAdminLocalization" v-model.trim="form.City" :label="(isAdminLocalization ? adminText('adminAll.city_427162', 'City') : $t('cityOptional', 'City'))" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field :admin-context="isAdminLocalization" v-model.trim="form.postalCode" :label="(isAdminLocalization ? adminText('adminAll.postal_code_d7432c', 'Postal code') : $t('postalCode', 'Postal code'))" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field :admin-context="isAdminLocalization" v-model.trim="form.Country" :label="(isAdminLocalization ? adminText('adminAll.country_d523eb', 'Country') : $t('countryOptional', 'Country'))" />
    </v-flex>
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'user-profile',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedLanguage: '',
      allLanguages: require('../../assets/languages.json'),
      form: {
        ...this.initialValues,
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    Object.entries(this.allLanguages).find(([key, value]) => {
      if (key === this.initialValues.preferredLanguage) {
        this.selectedLanguage = value.name
      }
    })
  },
  methods: {
    selectLan(language) {
      let selectedLanguage
      Object.entries(this.allLanguages).find(([key, value]) => {
        if (value.name === language) {
          return (selectedLanguage = key)
        }
      })
      this.form.preferredLanguage = selectedLanguage
    },
    getLanguagesList() {
      const list = []
      Object.entries(this.allLanguages).forEach(([key, value]) => {
        list.push(value.name)
      })

      return list
    },
  },
}
</script>

<style scoped></style>
